module.exports = __webpack_public_path__ + "static/iso-appliance-512-545517cf71211505b5370a17297eee24.png";